import { useEffect, useRef } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Asset, Box, Button, Card, Typography } from '@altermaind/web/ui';
import { useDialog } from '@/_shared/hooks/useDialog';
import { useResponsiveStyle } from '@/_shared/hooks/useResponsiveStyle';

export const UsefulInformation = () => {
  const t = useTranslations('departments.usefullInformations');
  const { genericResponsiveValue } = useResponsiveStyle();
  const { openDialog: openDialogDepartmentsTutorial } = useDialog('departmentsTutorial');
  const box1 = useRef(null);
  const box2 = useRef(null);

  const openTutorial = () => {
    openDialogDepartmentsTutorial();
  };

  useEffect(() => {
    if (box1.current && box2.current) {
      const heightBox1 = (box1.current as HTMLDivElement).offsetHeight;
      const heightBox2 = (box2.current as HTMLDivElement).offsetHeight;
      if (heightBox1 > heightBox2) {
        (box2.current as HTMLDivElement).style.height = `${heightBox1}px`;
      }
      if (heightBox2 > heightBox1) {
        (box1.current as HTMLDivElement).style.height = `${heightBox2}px`;
      }
    }
  }, [box1, box2]);

  return (
    <Box>
      <Typography variant='h3' mt='l' mb='s'>
        {t('title')}
      </Typography>
      <Box
        display='grid'
        gridTemplateColumns={genericResponsiveValue({
          breakPoints: { desktop: 'repeat(2, 1fr)' },
          defaultValue: 'repeat(1, 1fr)',
        })}
      >
        <Box
          ref={box1}
          mr={genericResponsiveValue({
            breakPoints: { desktop: 'xs' },
            defaultValue: 'none',
          })}
          mb={genericResponsiveValue({
            breakPoints: { desktop: 'none' },
            defaultValue: 'xs',
          })}
        >
          <Card p='xs'>
            <Box
              flexDirection={genericResponsiveValue({
                breakPoints: { desktop: 'row' },
                defaultValue: 'column',
              })}
              display='flex'
            >
              <Box
                flex='1'
                mb={genericResponsiveValue({
                  breakPoints: { desktop: 'none' },
                  defaultValue: 'xs',
                })}
              >
                <Asset
                  borderRadius='m'
                  domain='images'
                  name='departmentsTutorialImage'
                  width={genericResponsiveValue({
                    breakPoints: { desktop: 'auto' },
                    defaultValue: '100%',
                  })}
                  height={genericResponsiveValue({
                    breakPoints: { desktop: '130px' },
                    defaultValue: 'auto',
                  })}
                />
              </Box>
              <Box flex='1' alignSelf='center' px='xs'>
                <Typography variant='h2/light' fontSize='s'>
                  {t('boxTutorial.title')}
                </Typography>
                <Typography variant='p2/light' fontSize='xs'>
                  {t('boxTutorial.description')}
                </Typography>
                <Button onClick={openTutorial} variant='positive' mt='xs' p='xxs' height='m'>
                  {t('boxTutorial.buttonLabel')}
                </Button>
              </Box>
            </Box>
          </Card>
        </Box>
      </Box>
    </Box>
  );
};
